export default __webpack_public_path__ + "static/queries-nrql_screenshot-crop_dashboard-chart-color-cfff540a02d1a3b6d734ab419c851a05.webp";